import { initializeApp } from 'firebase/app'
import {
  getAuth,
  setPersistence,
  indexedDBLocalPersistence
} from 'firebase/auth'

/**
 * Firebase configuration object containing environment variables.
 * These variables are used to initialize and configure Firebase services.
 * 
 * @constant
 * @type {Object}
 * @property {string} apiKey - The API key for Firebase, retrieved from environment variables.
 * @property {string} authDomain - The authentication domain for Firebase, retrieved from environment variables.
 * @property {string} databaseURL - The database URL for Firebase, retrieved from environment variables.
 * @property {string} projectId - The project ID for Firebase, retrieved from environment variables.
 * @property {string} storageBucket - The storage bucket for Firebase, retrieved from environment variables.
 * @property {string} messagingSenderId - The messaging sender ID for Firebase, retrieved from environment variables.
 * @property {string} appId - The application ID for Firebase, retrieved from environment variables.
 * @property {string} measurementId - The measurement ID for Firebase analytics, retrieved from environment variables.
 */
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MESASUREMENT_ID
}

const firebase = initializeApp(firebaseConfig)

const auth = getAuth(firebase)
auth.languageCode = 'es'
setPersistence(auth, indexedDBLocalPersistence)

export { auth }
export default firebase
